import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FieldDateComponent, FieldTextComponent, FieldSelectComponent, FieldTextAreaComponent, AbstractFormComponent } from '@spike/scaffolds';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { EtiquetteStoreService } from '../../../configuration/services/etiquette-store.service';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, FieldTextAreaComponent, FormsModule, ReactiveFormsModule, FieldTextComponent, FieldDateComponent, FieldSelectComponent, OrganizationListComponent],
  selector: 'spike-order-general-form',
  templateUrl: './order-general-form.html'
})
export class OrderGeneralFormComponent extends AbstractFormComponent{
  private readonly formFactory = inject(FormFactoryService);
  public readonly organizationStore = inject(OrganizationStoreService);
  public readonly etiquetteStore = inject(EtiquetteStoreService);

  clientForm = this.formFactory.createCommonForm();

  clientApi= EntityApiEnum.CLIENT;
  clientModelApi = ModelApiEnum.CLIENT;
  clientEtiquetteApi= EtiquetteApiEnum.CLIENT;  
  

  onSelectEtiquette(etiquetteId: number|null) {
    this.form().controls['etiquetteId'].setValue(etiquetteId);
  }




}
